export default "__VITE_ASSET__CLWMZ_ad__"